/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import SEO from '../components/common/SEO';
import 'quill/dist/quill.snow.css';
import './InformationPageDetail.css';

const InformationPageDetail = () => {
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

    useEffect(() => {
        const fetchPageDetail = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${API_BASE_URL}/web-pages/information/slug/${slug}`);
                if (response.data.success) {
                    setPage(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching information page details:", error);
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchPageDetail();
        }
        window.scrollTo(0, 0);
    }, [slug]);

    const layoutStyle = { minHeight: '60vh', paddingTop: '120px' };

    if (loading) {
        return (
            <div className="main-wrapper">
                <Header />
                <div className="text-center" style={layoutStyle}>
                    <div className="spinner-border text-danger" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    if (!page) {
        return (
            <div className="main-wrapper">
                <Header />
                <div className="container text-center" style={layoutStyle}>
                    <h2>Page not found.</h2>
                    <p className="text-muted mt-3 mb-4">The web page you are looking for does not exist or has been removed.</p>
                    <Link to="/" className="btn btn-danger">Back to Home</Link>
                </div>
                <Footer />
            </div>
        );
    }

    const stripHtml = (html) => {
        if (!html) return '';
        return html.replace(/<[^>]+>/g, '').substring(0, 160) + '...';
    };

    return (
        <div className="main-wrapper" style={{ background: '#f8f9fa' }}>
            <SEO 
                title={page.meta_title || `${page.page_title} - Mangoloops`} 
                description={page.meta_desc || stripHtml(page.description)} 
                keywords={page.meta_keywords}
                ogTitle={page.meta_title || `${page.page_title} - Mangoloops`}
                ogDescription={page.meta_desc || stripHtml(page.description)}
            />
            <Header />
            
            <main style={{ paddingTop: '120px', paddingBottom: '60px', minHeight: '70vh' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="card border-0 shadow-sm rounded-4 bg-white p-4 p-md-5">
                                <div className="ql-container ql-snow" style={{ border: 'none' }}>
                                    <div 
                                        className="ql-editor"
                                        style={{ padding: 0, height: 'auto', minHeight: 'auto', overflowY: 'visible' }}
                                        dangerouslySetInnerHTML={{ __html: page.description || '' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            
            <Footer />
        </div>
    );
};

export default InformationPageDetail;
